function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable react/no-this-in-sfc */
import PropTypes from 'prop-types';
import React, { PureComponent, createRef, forwardRef } from 'react';
import Button from '../Button';
import Icon from '../Icon';
import Link from '../Link';
import classNames from '../utils/classNames';
var ELLIPSIS_UNICODE = "\u2026";
var MAX_PAGES = 5;
var PageControl = /*#__PURE__*/forwardRef(function (props, ref) {
  var href = props.href;
  var Component = href ? Link : Button;
  return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    ref: ref
  }));
});
PageControl.defaultProps = {
  href: null
};
PageControl.propTypes = {
  href: PropTypes.string
};
/**
 * Pagination component provides controls for navigating a collection of pages
 *
 * - [Design Spec](https://atlas.np.tools.playstation.net/design/eb1926ae-71b1-4eca-9221-d914dcaf5ddd/2?bounds=-2.381,0.000,5.762,3.914)
 *
 * ## Related Components
 * - [Button](https://github.sie.sony.com/SIE/web-common-toolkit/tree/master/packages/ui/react-components/src/Button)
 * - [Link](https://github.sie.sony.com/SIE/web-common-toolkit/tree/master/packages/ui/react-components/src/Link)
 *
 * ## Usage
 *
 * ```jsx
 * <Pagination
 *  currentPage={2}
 *  totalPages={10}
 * >
 *    {({ type, page, Component }) => {
 *      const makeAriaLabel = insert => `Visit ${insert} ${page} of 9`;
 *
 *      return (
 *        <NextLikeLink
 *          href={`#page-${page}`}
 *        >
 *          <Component
 *            ariaLabel={makeAriaLabel(type !== 'page' ? `${type} page,` : 'page')}
 *          />
 *        </NextLikeLink>
 *      );
 *    }}
 * </Pagination>
 * ```
 *
 * The Pagination component should be used with Links and the above usage example should be
 * considered canonical. Using Links is beneficial for SEO as well
 * as accessibility, however if you don't have hrefs the Pagination will work with
 * Buttons by default.
 *
 * ```jsx
 * <Pagination
 *  currentPage={2}
 *  totalPages={10}
 *  onChange={({ totalPages, currentPage, selectedPage }) => (
 *    console.log('user selected', selectedPage, `currently on ${currentPage} of ${totalPages})
 *  )}
 * />
 * ```
 *
 */

var Pagination = /*#__PURE__*/function (_PureComponent) {
  _inherits(Pagination, _PureComponent);

  var _super = _createSuper(Pagination);

  function Pagination() {
    var _this;

    _classCallCheck(this, Pagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (_ref, type) {
      var value = _ref.target.value;
      var _this$props = _this.props,
          currentPage = _this$props.currentPage,
          totalPages = _this$props.totalPages,
          onChange = _this$props.onChange;

      if (typeof onChange !== 'function') {
        return;
      }

      var numberValue = parseInt(value, 10);
      if (numberValue === currentPage) return;
      onChange({
        totalPages: totalPages,
        currentPage: currentPage,
        selectedPage: numberValue,
        type: type
      });
    });

    return _this;
  }

  _createClass(Pagination, [{
    key: "getPages",

    /**
     * Gets the pages which need to present controls for the user
     * @returns {Array.<Number|String>} only string value will be '...'
     *  to indicate the ellipsis element
     */
    value: function getPages() {
      var _this$props2 = this.props,
          currentPage = _this$props2.currentPage,
          totalPages = _this$props2.totalPages;
      var pages = this.shouldShowEllipsis() ? ['...', totalPages] : [];
      var startAt;

      if (currentPage === 1 || totalPages <= MAX_PAGES) {
        startAt = 0;
      } else if (currentPage >= totalPages - 3 && totalPages > MAX_PAGES) {
        startAt = totalPages - MAX_PAGES;
      } else {
        startAt = currentPage - 2;
      }

      for (var i = MAX_PAGES - pages.length; i > 0; i -= 1) {
        if (startAt + i <= totalPages) {
          pages = [startAt + i].concat(pages);
        }
      }

      return pages;
    }
  }, {
    key: "isNextDisabled",
    value: function isNextDisabled() {
      var _this$props3 = this.props,
          currentPage = _this$props3.currentPage,
          totalPages = _this$props3.totalPages;
      return totalPages === 1 || currentPage === totalPages;
    }
  }, {
    key: "isPreviousDisabled",
    value: function isPreviousDisabled() {
      var _this$props4 = this.props,
          currentPage = _this$props4.currentPage,
          totalPages = _this$props4.totalPages;
      return totalPages === 1 || currentPage === 1;
    }
  }, {
    key: "shouldShowEllipsis",
    value: function shouldShowEllipsis() {
      var _this$props5 = this.props,
          currentPage = _this$props5.currentPage,
          totalPages = _this$props5.totalPages;
      var adjustment = currentPage === 1 ? 1 : 0;
      return currentPage < totalPages - 3 - adjustment;
    }
  }, {
    key: "renderPrevious",
    value: function renderPrevious() {
      var _this2 = this;

      var _this$props6 = this.props,
          qa = _this$props6.qa,
          currentPage = _this$props6.currentPage,
          children = _this$props6.children,
          format = _this$props6.format;
      var disabled = this.isPreviousDisabled();
      var Component = /*#__PURE__*/forwardRef(function (props, ref) {
        return /*#__PURE__*/React.createElement(PageControl, _extends({
          ariaLabel: format('string', 'msgid_sr_go_to_previous_page')
        }, props, {
          qa: "".concat(qa, "#previous"),
          rel: "prev",
          value: currentPage - 1,
          variant: "quick-action",
          disabled: disabled,
          onClick: function onClick(event) {
            _this2.handleOnChange(event, 'previous');

            if (typeof props.onClick === 'function') {
              props.onClick(event);
            }
          },
          ref: ref
        }), /*#__PURE__*/React.createElement(Icon, {
          type: "chevron-left"
        }));
      });

      if (typeof children === 'function') {
        return children({
          type: 'previous',
          page: currentPage - 1,
          Component: Component
        });
      }

      var prevRef = /*#__PURE__*/createRef(null);
      return /*#__PURE__*/React.createElement(Component, {
        ref: prevRef
      });
    }
  }, {
    key: "renderPages",
    value: function renderPages() {
      var _this3 = this;

      var _this$props7 = this.props,
          qa = _this$props7.qa,
          currentPage = _this$props7.currentPage,
          children = _this$props7.children,
          format = _this$props7.format;
      var pages = this.getPages();
      return pages.map(function (page) {
        var isEllipsis = page === '...';
        var Component = /*#__PURE__*/forwardRef(function (props, ref) {
          return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(PageControl, _extends({}, props, {
            qa: "".concat(qa, "#page").concat(page),
            ariaLabel: format('string', 'msgid_sr_page_num', page),
            "aria-current": page === currentPage ? 'page' : null,
            "aria-hidden": isEllipsis,
            ariaDisabled: page === currentPage,
            variant: "page",
            active: page === currentPage,
            value: page,
            disabled: isEllipsis,
            onClick: function onClick(event) {
              _this3.handleOnChange(event, 'page');

              if (typeof props.onClick === 'function') {
                props.onClick(event);
              }
            },
            ref: ref
          }), isEllipsis ? ELLIPSIS_UNICODE : page));
        });

        if (!isEllipsis && typeof children === 'function') {
          return children({
            type: 'page',
            page: page,
            Component: Component
          });
        }

        var pageRef = /*#__PURE__*/createRef(null);
        return /*#__PURE__*/React.createElement(Component, {
          ref: pageRef,
          key: page
        });
      });
    }
  }, {
    key: "renderNext",
    value: function renderNext() {
      var _this4 = this;

      var _this$props8 = this.props,
          qa = _this$props8.qa,
          currentPage = _this$props8.currentPage,
          children = _this$props8.children,
          format = _this$props8.format;
      var disabled = this.isNextDisabled();
      var Component = /*#__PURE__*/forwardRef(function (props, ref) {
        return /*#__PURE__*/React.createElement(PageControl, _extends({
          ariaLabel: format('string', 'msgid_sr_go_next_page')
        }, props, {
          qa: "".concat(qa, "#next"),
          rel: "next",
          variant: "quick-action",
          value: currentPage + 1,
          disabled: disabled,
          onClick: function onClick(event) {
            _this4.handleOnChange(event, 'next');

            if (typeof props.onClick === 'function') {
              props.onClick(event);
            }
          },
          ref: ref
        }), /*#__PURE__*/React.createElement(Icon, {
          type: "chevron-right"
        }));
      });

      if (typeof children === 'function') {
        return children({
          type: 'next',
          page: currentPage + 1,
          Component: Component
        });
      }

      var nextRef = /*#__PURE__*/createRef(null);
      return /*#__PURE__*/React.createElement(Component, {
        ref: nextRef
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
          qa = _this$props9.qa,
          className = _this$props9.className;
      return /*#__PURE__*/React.createElement("nav", {
        "data-qa": qa,
        className: className
      }, this.renderPrevious(), /*#__PURE__*/React.createElement("ol", {
        className: classNames('psw-l-space-x-1', 'psw-l-line-center', 'psw-list-style-none')
      }, this.renderPages()), this.renderNext());
    }
  }]);

  return Pagination;
}(PureComponent);

Pagination.defaultProps = {
  qa: 'pagination',
  className: '',
  currentPage: 1,
  totalPages: 1,
  children: null,
  onChange: function onChange() {},
  format: function format() {}
};
Pagination.propTypes = {
  /**
   * QA automation test ID, This id should be unique so two or more instances can be
   * selected separately
   */
  qa: PropTypes.string,

  /**
   * Additional classes to apply to the root. This is mainly for position / margin. The
   * underlying styles of the controls should not be altered.
   */
  className: PropTypes.string,

  /**
   * The currently selected page
   */
  currentPage: PropTypes.number,

  /**
   * The total number of pages
   */
  totalPages: PropTypes.number,

  /**
   * A render prop which affords wrapping / passing necessary props to the page control
   * components. The render prop function will receive and object with type (next, previous, page)
   * page (indicating the page of the control rendered) and Component which is the pre-configured
   * page controls.
   */
  children: PropTypes.func,

  /**
   * Links with hrefs should be preferred but in the case Links are not used onChange
   * can be used to be notified when a page is changed. This method will not work if
   * Links are used.
   */
  onChange: PropTypes.func,

  /**
   * Format function for Gensen strings
   */
  format: PropTypes.func
};
export default Pagination;